import { useState } from 'react'
import { useEffect } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/material'
import ToggleButton from '@mui/material/ToggleButton'
import { ToggleButtonGroup } from '@mui/material'
import { ParametersListCalendar } from './ParametersListCalendar'
import { ParametersListTable } from './ParametersListTable'
import { MonitorRunsResultDetailCard } from 'shared/types'

interface ResultSectionProps {
    marketSpyId?: number
    monitorLaunchTaskResult?: any
    monitorRunsResultDetailCard?: MonitorRunsResultDetailCard
    onSelectedMonitorLaunchTaskChange?: Function
}

export const ResultSection = (props: ResultSectionProps): JSX.Element => {
    const {
        marketSpyId,
        monitorRunsResultDetailCard,
        monitorLaunchTaskResult,
        onSelectedMonitorLaunchTaskChange,
    } = props

    const [viewMode, setViewMode] = useState('calendar')
    const handleSelectedMonitorLaunchTaskChange = (params: any) => {
        onSelectedMonitorLaunchTaskChange?.(params)
    }

    const parametersRender = () => {
        if (viewMode === 'table') {
            return (
                <ParametersListTable
                    monitorId={marketSpyId}
                />     
            )
        }

        if (viewMode === 'calendar') {
            return (
                <ParametersListCalendar
                    monitorId={marketSpyId}
                    monitorRunsResultDetailCard={monitorRunsResultDetailCard}
                    selectedMonitorLaunchTask={monitorLaunchTaskResult}
                    onSelectedMonitorLaunchTaskChange={handleSelectedMonitorLaunchTaskChange}
                />
            )
        }

        return (
            <>
                
            </>
        )
    }

    const viewModeChanged = (
        event: React.MouseEvent<HTMLElement>,
        newViewMode: string,
    ) => {
        setViewMode(newViewMode);
    };

    const toggleSelectorRender = () => {
        return (
            <>
                <ToggleButtonGroup
                    color="primary"
                    value={viewMode}
                    exclusive
                    onChange={viewModeChanged}
                    aria-label="view"

                >
                    <ToggleButton value="calendar">Calendar</ToggleButton>
                    <ToggleButton value="table">Table</ToggleButton>
                </ToggleButtonGroup>
            </>
        )
    }
    return (
        <Accordion disableGutters defaultExpanded={true}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: '#FFF' }} />}
                aria-controls="panel1a-content"
                sx={{
                    backgroundColor: '#FFF',
                    flexDirection: 'row-reverse',
                    padding: {
                        xs: '8px 12px', md: '8px 24px'
                    },
                    '& .MuiAccordionSummary-expandIconWrapper': {
                        padding: '12px 12px 12px 12px',
                        fill: '#717171',
                        color: '#717171'
                    },

                    '& .MuiSvgIcon-root': {
                        fill: '#717171',
                        color: '#717171'
                    },

                    '& .MuiAccordionSummary-content': {
                        flexDirection: {
                            xs: 'column',
                            sm: 'row'
                        }
                    },

                }}
            >
                <Typography sx={
                    {
                        fontSize: {
                            xs: '24px',
                            sm: '24px',
                            md: '24px',
                        },
                        lineHeight: '28px',
                        color: '#000',
                        fontWeight: 600,
                        marginRight: 2
                    }
                }
                >Results
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>   
                <Box p={2} sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}>    
                    {
                        toggleSelectorRender()
                    }
                </Box>
                <div style={{
                    width: "100%" 
                 }}>
                    {
                        parametersRender()
                    }               
                </div>
            </AccordionDetails>
        </Accordion>
    )
}